import './DateOverview.44fce3620f4ceb9ce69aceda0a3dae73.css';
export default {"dateOverview":"_dateOverview_1ymsq_1","date":"_date_1ymsq_1","calendarWeek":"_calendarWeek_1ymsq_1"};